import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MsalService } from '@azure/msal-angular';


@Injectable({ providedIn: 'root' })
export class AuthGuard  {
    constructor(
        private router: Router,
        private msalService: MsalService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const loggedIn = this.msalService.instance.getAllAccounts().length > 0;
        if (loggedIn) {
            return true;
        } else {
            // not logged in so redirect to unauthenticated page
            this.router.navigate(['/login-failed']);
        }
        return false;
    }
}
